module.exports = __webpack_public_path__ + "static/media/passSuccess.svg";